import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";

export const VaultHeaderWrapper = styled.div`
    padding: 40px 0px 24px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    gap: 16px;
    
    @media (max-width: 1024px) {
        gap: 12px;
    }
    
    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        gap: 16px;
    }
`;

export const VaultButtonsWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
`;

export const VaultButton = styled.div`
    display: flex;
    height: 40px;
    padding: 0px 18px 1px 16px;
    align-items: center;
    gap: 8px;
    border-radius: 10px;

    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;

    cursor: pointer;
`;

export const VaultButtonBlack = styled(VaultButton)`
    background: ${colors.darkGray1};
    color: var(--Main-Colors-White, #FFF);

    &:hover {
        background: var(--Main-Colors-Dark-Grey-2, #2B2C2E);
    }
`;

export const VaultButtonTransparent = styled(VaultButton)`
    gap: 4px;
    border: 1px solid #D1D4DA;
    color: var(--Dark-Gray-1, #1A1B1D);
    padding: 0px 16px 1px 18px;

    svg {
        width: 24px;
        height: 24px;
    }
`;